import {Box, Flex, Text} from '@chakra-ui/react';
import {kAppStoreUrl, kGooglePlayUrl} from 'config';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import NextImageUI from 'ui/NextImage';

import {SocialNetwork} from './components/SocialNetwork';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const DownloadApp: FC<IProps> = ({t}) => {
  return (
    <Flex w="45%" flexDirection="column">
      <Text>{t('DOWNLOAD_THE_APPLICATION')}</Text>
      <Text fontSize={['12px', '16px']} fontWeight="500">
        {t('DOWNLOAD_THE_APPLICATION_SUB_TITLE')}
      </Text>
      <Flex alignItems="center" mt="20px" justifyContent="space-between">
        <Box w="45%">
          <a href={kAppStoreUrl} target="_blank" rel="noreferrer">
            <NextImageUI width={801} height={267} src="/get-app-store.webp" alt="Get on app store" />
          </a>
        </Box>
        <Box w="45%">
          <a href={kGooglePlayUrl} target="_blank" rel="noreferrer">
            <NextImageUI width={564} height={170} src="/get-google-play.webp" alt="Get app on google Play" />
          </a>
        </Box>
      </Flex>
      <SocialNetwork t={t} />
    </Flex>
  );
};
